import { Layout, Menu, Button, Typography } from "antd";
import {
  DashboardOutlined,
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router";

const { Sider } = Layout;
const { Text } = Typography;

interface SidebarProps {
  collapsed: boolean;
  onCollapse: (collapsed: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determinar la sección activa basada en la ruta actual
  const getActiveSection = () => {
    if (location.pathname === "/") return "workspace";
    if (location.pathname === "/settings") return "settings";
    if (location.pathname.startsWith("/project/")) return "workspace";
    return "workspace";
  };

  const menuItems = [
    {
      key: "workspace",
      icon: <DashboardOutlined />,
      label: "Área de trabajo",
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Configuración",
    },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    switch (key) {
      case "workspace":
        navigate("/");
        break;
      case "settings":
        navigate("/settings");
        break;
      default:
        navigate("/");
    }
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 64, // Header height
        zIndex: 100,
        background: "#fff",
        borderRight: "1px solid #d9d9d9",
      }}
      width={240}
      collapsedWidth={60}
    >
      <div style={{ padding: "16px 0" }}>
        <div style={{ padding: "0 16px", marginBottom: "16px" }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => onCollapse(!collapsed)}
            style={{
              fontSize: "16px",
              width: collapsed ? "100%" : "auto",
              height: "32px",
            }}
          />
        </div>

        {!collapsed && (
          <>
            <div style={{ padding: "0 16px", marginBottom: "16px" }}>
              <Text type="secondary" style={{ fontSize: "12px" }}>
                NAVEGACIÓN PRINCIPAL
              </Text>
            </div>
          </>
        )}

        <Menu
          mode="inline"
          selectedKeys={[getActiveSection()]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{
            border: "none",
            background: "transparent",
          }}
        />
      </div>
    </Sider>
  );
};

export default Sidebar;
